document.addEventListener('teeinblue-event-after-cart-added', function() {
  var request = new XMLHttpRequest();
  
  request.open('GET', '/cart.js', true);

  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      var itemCount = data.item_count;
      var cartCount = document.querySelectorAll('#cart-icon-bubble');
      
      if (cartCount.length && itemCount > 0) {
        cartCount.forEach(function(cart) {
          cart.innerHTML = '<svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg><span class="visually-hidden">Cart</span><div class="cart-count-bubble"><span aria-hidden="true">'+ itemCount +'</span><span class="visually-hidden">'+ itemCount +' items</span></div>';
        });
      } else {
        cartCount.forEach(function(cart) {
          cart.innerHTML = '<svg class="icon icon-cart-empty" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path d="m15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.78-11.61zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1 -9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" fill="currentColor" fill-rule="evenodd"></path></svg><span class="visually-hidden">Cart</span>';
        });
      }
    }
  };

  request.send();
});

/*
EVENT_PAGE_CHANGED: "teeinblue-event-page-changed",
EVENT_CART_REFRESHED: "teeinblue-event-cart-refreshed",
EVENT_BEFORE_CUSTOMIZATION_CREATED: "teeinblue-event-before-customization-created",
EVENT_BEFORE_CART_ADDED: "teeinblue-event-before-cart-added",
EVENT_AFTER_CART_ADDED: "teeinblue-event-after-cart-added",
EVENT_COMPONENT_INJECTED: "teeinblue-event-component-injected",
EVENT_VARIANT_CHANGED: "teeinblue-event-variant-changed",
EVENT_SHOPIFY_CART_UPDATED: "shopify-event-cart-updated",
EVENT_SHOPIFY_CART_MODIFIED: "shopify-event-cart-modified",
EVENT_SHOPIFY_CART_AJAX: "shopify-event-cart-ajax",
EVENT_CLONE_NODE: "teeinblue-event-clone-node",
*/

function addParamsToUrl(params) {
  // 1. Obtenez l'URL courante
  const currentUrl = window.location.href;

  // 2. Créez un objet URL avec l'URL courante
  const url = new URL(currentUrl);

  // 3. Ajoutez chaque paramètre à l'URL
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      url.searchParams.set(key, params[key]);
    }
  }

  // 4. Mettez à jour l'URL sans recharger la page
  window.history.pushState({}, '', url);

  // Affichez l'URL mise à jour dans la console
  console.log('Updated URL:', url.toString());
}

document.addEventListener("teeinblue-event-clone-node", (event) => {
  console.log("teeinblue-event-clone-node", event);
});

document.addEventListener("teeinblue-event-component-injected", (event) => {
  const form = document.getElementById('teeFormInputs');
  
  /*form.querySelectorAll('input, textarea, select').forEach(function(element) {
    element.addEventListener('change', function(event) {
      console.log('Element changed:', event.target.name, 'New value:', event.target.value);
    });
  });*/

  form.querySelectorAll('.tee-clipart').forEach(function(element) {
    let radio = event.target.querySelector("radio");
    element.addEventListener('mouseup', function(event) {
      console.log('radio mouseup:', radio, 'New value:', radio);
    });
  });  
});